// Bootstrap do app Vue — Pinia, Router e estilos globais

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useThemeStore } from '@/stores/theme';
import './assets/main.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
// Aplica o tema salvo (default dark) antes de montar, evitando flash de tema errado.
useThemeStore().apply();
app.mount('#app');
